export default "__VITE_ASSET__DhZg43iX__"